import { render, staticRenderFns } from "./poiid-bind.vue?vue&type=template&id=06db0afa&scoped=true&"
import script from "./poiid-bind.vue?vue&type=script&lang=js&"
export * from "./poiid-bind.vue?vue&type=script&lang=js&"
import style0 from "./poiid-bind.vue?vue&type=style&index=0&id=06db0afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db0afa",
  null
  
)

export default component.exports